(()=>{
  const root=()=>document.querySelector('[data-jol-fit-guide-root]');
  const overlay=()=>document.querySelector('[data-jol-fit-guide-overlay]');
  const label=()=>root()?.dataset.linkText||'See how it fits';
  let lastTrigger=null;
  let openedFromQuickView=false;
  let fitGuideHistoryActive=false;
  let closeTimer=0;
  let activeFit='fitted';
  const reducedMotion=()=>window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  const normalizeFit=value=>{const text=String(value||'').toLowerCase();return text.includes('relaxed')?'relaxed':text.includes('fitted')?'fitted':'';};
  const detectFitFromTrigger=trigger=>{
    const scope=trigger?.closest?.('.jol-quickview,.product-details,product-information')||document;
    const qvSelected=scope.querySelector?.('.jol-quickview__option--fit .jol-option-btn.is-selected');
    const qvFit=normalizeFit(qvSelected?.dataset?.optionValue||qvSelected?.textContent);
    if(qvFit)return qvFit;
    const checked=[...scope.querySelectorAll?.('variant-picker input:checked')||[]].find(input=>{
      const optionName=String(input.dataset.optionName||'').toLowerCase();
      return optionName.includes('fit')||normalizeFit(input.value);
    });
    const checkedFit=normalizeFit(checked?.value||checked?.getAttribute?.('aria-label'));
    return checkedFit||'';
  };
  const applyFit=fit=>{
    const r=root();if(!r)return;
    activeFit=normalizeFit(fit)||activeFit||'fitted';
    r.dataset.activeFit=activeFit;
    r.querySelectorAll('[data-jol-fit-select]').forEach(btn=>{
      const selected=btn.dataset.jolFitSelect===activeFit;
      btn.classList.toggle('is-active',selected);
      btn.setAttribute('aria-pressed',selected?'true':'false');
    });
    r.querySelectorAll('[data-jol-fit-card-fit]').forEach(card=>card.classList.toggle('is-active',card.dataset.jolFitCardFit===activeFit));
    r.querySelectorAll('[data-jol-model-fit]').forEach(card=>{
      const cardFit=normalizeFit(card.dataset.jolModelFit);
      const both=String(card.dataset.jolModelFit||'').toLowerCase()==='both'||!cardFit;
      card.hidden=!(both||cardFit===activeFit);
    });
    r.querySelectorAll('[data-jol-model-section]').forEach(section=>{
      section.hidden=![...section.querySelectorAll('[data-jol-model-fit]')].some(card=>!card.hidden);
    });
    r.querySelectorAll('[data-jol-measurement-fit]').forEach(sheet=>{sheet.hidden=sheet.dataset.jolMeasurementFit!==activeFit;});
  };
  const finishClose=(el)=>{
    window.clearTimeout(closeTimer);
    closeTimer=0;
    el.classList.remove('is-open','is-closing');
    el.hidden=true;
    document.body.classList.remove('jol-fit-guide-open');
    openedFromQuickView=false;
    lastTrigger?.focus?.({preventScroll:true});
  };
  const openGuide=(trigger,options={})=>{
    const el=overlay();if(!el)return;
    window.clearTimeout(closeTimer);closeTimer=0;
    lastTrigger=trigger||document.activeElement;
    openedFromQuickView=Boolean(trigger?.closest?.('[data-jol-quickview-overlay]'));
    applyFit(detectFitFromTrigger(trigger)||activeFit);
    el.hidden=false;
    el.classList.remove('is-closing');
    document.body.classList.add('jol-fit-guide-open');
    if(!options.skipHistory&&!fitGuideHistoryActive){try{history.pushState({...(history.state||{}),jolFitGuide:true},'',window.location.href);fitGuideHistoryActive=true;}catch(e){}}
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      el.classList.add('is-open');
      el.querySelector('.jol-fit-guide__close')?.focus();
    }));
  };
  const closeGuide=(options={})=>{
    const el=overlay();if(!el||el.hidden||el.classList.contains('is-closing'))return;
    const shouldStepBack=fitGuideHistoryActive&&!options.fromPopstate;
    fitGuideHistoryActive=false;
    el.classList.remove('is-open');
    el.classList.add('is-closing');
    if(shouldStepBack){window.__jolSuppressQuickViewPopstate=true;try{history.back();}catch(e){}}
    if(reducedMotion()){finishClose(el);return;}
    closeTimer=window.setTimeout(()=>finishClose(el),860);
  };
  const makeTrigger=(cls='')=>{const b=document.createElement('button');b.type='button';b.className=`jol-fit-guide__trigger ${cls}`.trim();b.dataset.jolFitGuideTrigger='';b.innerHTML=`<span class="jol-fit-guide__trigger-main">${label()}</span><span class="jol-fit-guide__trigger-icon" aria-hidden="true">−</span>`;return b;};
  const hasFit=(picker)=>{const t=(picker?.textContent||'').toLowerCase();return /(^|\s)fit(\s|$)/.test(t)||t.includes('fitted')||t.includes('relaxed');};
  const scan=()=>{
    const r=root();if(!r)return;
    if(r.dataset.pageEligible==='true'){
      const details=document.querySelector('.template-product .product-details');
      if(details&&!details.querySelector('[data-jol-fit-guide-product-trigger]')){
        const picker=details.querySelector('variant-picker');
        const anchor=picker||details.querySelector('product-form-component')||details.querySelector('.buy-buttons-block');
        if(anchor){const b=makeTrigger('jol-fit-guide__trigger--product');b.dataset.jolFitGuideProductTrigger='';anchor.insertAdjacentElement(picker?'afterend':'beforebegin',b);}
      }
    }
    document.querySelectorAll('quick-add-dialog variant-picker, quick-add-modal variant-picker, .quick-add-modal variant-picker, dialog variant-picker').forEach(picker=>{
      if(!hasFit(picker))return;
      const parent=picker.parentElement;if(!parent||parent.querySelector(':scope > [data-jol-fit-guide-native-trigger]'))return;
      const b=makeTrigger('jol-fit-guide__trigger--product');b.dataset.jolFitGuideNativeTrigger='';picker.insertAdjacentElement('afterend',b);
    });
  };
  document.addEventListener('click',e=>{
    const fitSelect=e.target.closest?.('[data-jol-fit-select]');
    if(fitSelect){e.preventDefault();applyFit(fitSelect.dataset.jolFitSelect);return;}
    const trigger=e.target.closest?.('[data-jol-fit-guide-trigger]');
    if(trigger){e.preventDefault();openGuide(trigger);return;}
    if(e.target.closest?.('[data-jol-fit-guide-close]')){e.preventDefault();closeGuide();}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&overlay()&&!overlay().hidden)closeGuide();});
  window.addEventListener('popstate',()=>{const el=overlay();if(el&&!el.hidden){fitGuideHistoryActive=false;closeGuide({fromPopstate:true});}});

  // V197: selecting LJ Fit Guide or one of its model blocks in Shopify's editor opens the guide for live editing.
  document.addEventListener('shopify:section:select',e=>{
    if(e.detail?.sectionId&&e.target?.classList?.contains('jol-fit-guide-editor-section')) openGuide(null,{skipHistory:true});
  });
  document.addEventListener('shopify:block:select',e=>{
    if(e.target?.closest?.('.jol-fit-guide-editor-section')) openGuide(null,{skipHistory:true});
  });

  // Mobile: swipe left-to-right to return the Fit Guide toward the right edge it entered from.
  // Horizontal model comparison rows keep their own swipe behavior.
  let swipeStartX=0;
  let swipeStartY=0;
  let swipeTracking=false;
  document.addEventListener('touchstart',e=>{
    const panel=e.target.closest?.('.jol-fit-guide__panel');
    if(!panel||window.innerWidth>=750||e.touches.length!==1||e.target.closest('.jol-fit-guide__models'))return;
    swipeStartX=e.touches[0].clientX;
    swipeStartY=e.touches[0].clientY;
    swipeTracking=true;
  },{passive:true});
  document.addEventListener('touchmove',e=>{
    if(!swipeTracking||e.touches.length!==1)return;
    const deltaX=e.touches[0].clientX-swipeStartX;
    const deltaY=e.touches[0].clientY-swipeStartY;
    if(deltaX>0&&Math.abs(deltaX)>Math.abs(deltaY)+10)e.preventDefault();
  },{passive:false});
  document.addEventListener('touchend',e=>{
    if(!swipeTracking)return;
    swipeTracking=false;
    const touch=e.changedTouches[0];if(!touch)return;
    const deltaX=touch.clientX-swipeStartX;
    const deltaY=touch.clientY-swipeStartY;
    if(deltaX>=70&&Math.abs(deltaX)>Math.abs(deltaY)*1.25)closeGuide();
  },{passive:true});
  document.addEventListener('touchcancel',()=>{swipeTracking=false;},{passive:true});

  const init=()=>{scan();applyFit(activeFit);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  const observer=new MutationObserver(()=>scan());observer.observe(document.documentElement,{childList:true,subtree:true});
})();